import { push } from 'connected-react-router'
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import type {
  IUpdateProgramInteractionResponse} from '@app/domain/program/program.rest';
import {
  startInteraction
} from '@app/domain/program/program.rest'
import type { AppAction, AppState } from '@app/state'

import * as User from '../user/state'
import {
  getUserPreferences,
  patchUserPreferences,
} from '../user-preferences/user-preferences.interface'

import * as VisitList from './state'

import type { AxiosResponse } from 'axios'

function* handleLoadVisitListStateFromLocalStorage() {
  yield takeEvery(
    User.ActionType.GetAccountInfoSucceeded,
    loadStateFromLocalStorage,
  )
}

function* loadStateFromLocalStorage(action: AppAction) {
  if (action.type === User.ActionType.GetAccountInfoSucceeded) {
    const appState: AppState = yield select((a) => a)
    const storedUserPreferences = getUserPreferences(action.userId)
    const storedVisitListState = storedUserPreferences.visitList ?? {}
    yield put(
      VisitList.actions.setState({
        ...appState.visitList,
        ...storedVisitListState,
      }),
    )
  }
}

function* handleSaveVisitListStateToLocalStorage() {
  yield takeLatest(
    [
      VisitList.ActionType.SetLocationFilter,
      VisitList.ActionType.SetMrnFilter,
      VisitList.ActionType.SetPageNumber,
      VisitList.ActionType.SetPatientNameFilter,
      VisitList.ActionType.SetRecordsPerPage,
      VisitList.ActionType.SetSort,
      VisitList.ActionType.SetStatusFilter,
      VisitList.ActionType.SetTypeFilter,
    ],
    saveToLocalStorage,
  )
}

function* saveToLocalStorage(_action: AppAction) {
  const appState: AppState = yield select((a) => a)
  const userId = appState.user.account.userId
  patchUserPreferences(userId, {
    visitList: appState.visitList,
  })
}

export function* handleLaunchIntake() {
  yield takeEvery(VisitList.ActionType.LaunchIntake, launchIntake)
}

export function* launchIntake(action: AppAction) {
  if (action.type === VisitList.ActionType.LaunchIntake) {
    try {
      const appState: AppState = yield select((a) => a)

      const request = startInteraction(
        action.visitId,
        action.selectedInteractionIds,
      )

      const response: AxiosResponse<IUpdateProgramInteractionResponse> = yield call(
        request,
        appState.config.apiLocation,
        appState.auth.token,
      )

      if (response.status === 200) {
        yield put(VisitList.actions.closeLaunchIntakeModal())
        yield put(push(`/intake/visit/${action.visitId}`))
      } else {
        yield put(
          VisitList.actions.launchIntakeFailed(
            'Error updating visit definition.',
          ),
        )
      }
    } catch (e) {
      yield put(
        VisitList.actions.launchIntakeFailed(
          'Error updating visit definition.',
        ),
      )
    }
  }
}

export const sagas = {
  handleLaunchIntake,
  handleLoadVisitListStateFromLocalStorage,
  handleSaveVisitListStateToLocalStorage,
}
